var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 242,
    viewBox: "0 0 392 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.96 131.877C173.374 93.7513 191.894 80.2636 211.813 75.7749C246.755 67.9012 255.033 90.7087 261.04 107.774C277.322 157.928 288.061 235.774 194.04 235.774C62.987 235.774 74.2756 201.111 85.0402 183.774C92.7503 171.357 140.78 169.459 156.96 131.877Z",
    fill: "#F7F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 110.746L199 117.746L205.5 110.746H226.5C227.052 110.746 227.5 110.298 227.5 109.746V61.7456C227.5 61.1933 227.052 60.7456 226.5 60.7456H170C169.448 60.7456 169 61.1933 169 61.7456V109.746C169 110.298 169.448 110.746 170 110.746H192.5Z",
    fill: "#F8F9FA",
    stroke: "#C8C9C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.164 96.7916V94.9436C194.326 94.6576 192.72 93.2056 191.642 91.4456L194.04 89.9056C194.942 91.1596 195.8 92.1716 197.274 92.4576V87.7936C194.612 87.1336 192.082 86.1656 192.082 83.0416C192.082 80.2696 194.062 78.4876 197.164 78.2456V76.7276H199.276V78.3116C201.718 78.6416 203.038 79.8296 204.006 81.2156L201.63 82.9316C200.992 82.0076 200.332 81.2376 199.21 80.9296V85.2196C202.268 85.9456 204.578 87.0016 204.578 90.1036C204.578 92.5236 203.016 94.6136 199.276 94.9436V96.7916H197.164ZM199.21 88.2996V92.4796C200.618 92.2816 201.322 91.6436 201.322 90.4336C201.322 89.3336 200.64 88.7396 199.21 88.2996ZM197.274 84.7136V80.7976C195.954 80.9736 195.338 81.7436 195.338 82.7336C195.338 83.8116 195.998 84.3176 197.274 84.7136Z",
    fill: "#53565A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.304 210.56C123.304 209.455 124.199 208.56 125.304 208.56H136.976C138.08 208.56 138.976 209.455 138.976 210.56V235.202H123.304V210.56Z",
    fill: "#006FCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 180.784C168.752 179.679 167.857 178.784 166.752 178.784H155.864C154.759 178.784 153.864 179.679 153.864 180.784V235.202H168.752V180.784Z",
    fill: "#006FCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.641 192.538C183.641 191.433 184.536 190.538 185.641 190.538H196.529C197.633 190.538 198.529 191.433 198.529 192.538V235.202H183.641V192.538Z",
    fill: "#006FCF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M213.417 152.574C213.417 151.47 214.312 150.574 215.417 150.574H227.089C228.193 150.574 229.089 151.47 229.089 152.574V235.202H213.417V152.574Z",
    fill: "#006FCF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M243.193 187.836C243.193 186.731 244.089 185.836 245.193 185.836H256.865C257.97 185.836 258.865 186.731 258.865 187.836V235.202H243.193V187.836Z",
    fill: "#006FCF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.516 130.437C204.973 133.028 203.244 135.5 200.653 135.957C198.062 136.415 195.59 134.685 195.132 132.094C194.675 129.503 196.404 127.032 198.995 126.574C201.586 126.116 204.058 127.846 204.516 130.437Z",
    fill: "#00175A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.804 135.246L179.304 155.746L151.804 161.246L140.804 182.246L120.304 191.746",
    stroke: "#00175A",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/Image1.4f4cf13519f3072492f2153f273ffaa7.svg";
export { ForwardRef as ReactComponent };